<template>
  <gj-tree-select
      v-bind="$attrs"
      v-on="$listeners"
      :data="treeData"
      :show-checkbox="multiple"
      :expand-on-click-node="!multiple"
      :placeholder="placeholder"
      :fixedWidth="fixedWidth"
  >
    <template v-slot:default="{node, data }">
      <gj-tooltip :content="node.label" effect="light" :text-line="1">{{ node.label }} <span v-if="node.isLeaf && data.state==='Inactive'" class="country">停用</span></gj-tooltip>
    </template>
  </gj-tree-select>
</template>

<script>
  import {mapGetters} from "vuex";
  import {
    WAREHOUSE_GET_ACTIVE_FBA_WAREHOUSE_TREE,
    WAREHOUSE_GET_ACTIVE_SELF_WAREHOUSE_TREE,
    WAREHOUSE_GET_ACTIVE_WAREHOUSE_TREE,
    WAREHOUSE_GET_FBA_WAREHOUSE_TREE, WAREHOUSE_GET_SELF_WAREHOUSE_TREE,
    WAREHOUSE_GET_WAREHOUSE_TREE
  } from "../../store/action-types";

  export default {
    name: "gj-warehouse-select",
    props: {
      fba: {
        default: true
      },
      self: {
        default: true
      },
      active: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '仓库',
      },
      fixedWidth: {
        type: String,
        default: '240px'
      }
    },
    created() {
      let token = null;
      if (this.fba && this.self) {
        token = this.active ? WAREHOUSE_GET_ACTIVE_WAREHOUSE_TREE : WAREHOUSE_GET_WAREHOUSE_TREE
      } else if (this.fba) {
        token = this.active ? WAREHOUSE_GET_ACTIVE_FBA_WAREHOUSE_TREE : WAREHOUSE_GET_FBA_WAREHOUSE_TREE
      } else if (this.self) {
        token = this.active ? WAREHOUSE_GET_ACTIVE_SELF_WAREHOUSE_TREE : WAREHOUSE_GET_SELF_WAREHOUSE_TREE
      }
      if (token && this._.isEmpty(this.treeData)) {
        this.$store.dispatch(token);
      }
    },
    data() {
      return {
        loading: false
      }
    },
    computed: {
      ...mapGetters([
        'warehouseTree',
        'activeWarehouseTree',
        'fbaWarehouseTree',
        'activeFbaWarehouseTree',
        'selfWarehouseTree',
        'activeSelfWarehouseTree',
      ]),
      treeData() {
        if (this.fba && this.self) {
          return this.active ? this.activeWarehouseTree : this.warehouseTree
        } else if (this.fba) {
          return this.active ? this.activeFbaWarehouseTree : this.fbaWarehouseTree
        } else if (this.self) {
          return this.active ? this.activeSelfWarehouseTree : this.selfWarehouseTree
        } else {
          return [];
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
.country {
  margin-left: 8px;
  color: #bfbfbf;
}
</style>
